import React, { Component } from 'react'
import { Col, Container } from 'react-bootstrap'
import CondicionIngreso from '../../containers/CondicionIngreso'
import CaladoSwitch from '../../containers/CaladoSwitch'
import CalleGrande from '../../containers/CalleGrande'
import * as actions from '../../actions'
import { connect } from 'react-redux'
import { Card, CardActionArea, IconButton } from '@material-ui/core'
import EstadoIngresoAnterior from '../EstadoIngresoAnterior'
import { toast } from 'react-toastify'
import PrintIcon from '@material-ui/icons/Print'
import CampoHumedad from './CampoHumedad'

class CamposProcesoCalado1 extends Component {
  construct (props) {
    this.handleChange = this.handleChange.bind(this)
    this.updateShowCaladoConfirmacionAnulacion = this.updateShowCaladoConfirmacionAnulacion.bind(this)
    this.updateImpOblea = this.updateImpOblea.bind(this)
    this.imprimirEtiquetaIngreso = this.imprimirEtiquetaIngreso.bind(this)
    this.reimpresionEtiquetaIngreso = this.reimpresionEtiquetaIngreso.bind(this)
  }

  async componentDidMount () {
    const { impoblea, cpe, cpa, caladoImpresora, preingresoOn } = this.props
    this.props.updateHumedad(this.props.humedadInicial)
    // SE IMPRIME OBLEA AL COMIENZO DEL PROCESO
    console.log('Cpe a imprimir', cpe)
    if (impoblea) {
      await this.imprimirEtiquetaIngreso(cpe.nroCtge, caladoImpresora)
      // this.updateImpOblea(false)
      toast.success(`Imprimiendo oblea`)
    }
    if (cpa.claveCereal === 'CEBADACE') this.props.updatePendienteAutorizar(true)
    console.log(preingresoOn)
  }

  reimpresionEtiquetaIngreso (numero, impresora) {
    this.imprimirEtiquetaIngreso(numero, impresora)
    toast.success(`Reimprimiendo oblea`)
  }

  updateShowCaladoConfirmacionAnulacion (newShow) {
    this.props.updateShowCaladoConfirmacionAnulacion(newShow)
  }

  updateImpOblea (newValue) {
    this.props.updateImpOblea(newValue)
  }

  imprimirEtiquetaIngreso (numero, impresora) {
    console.log('A imprimir...', numero, impresora)
    if (numero && impresora) {
      console.log('Se imprime etiqueta')
      this.props.imprimirEtiquetaIngreso(numero, impresora)
    }
  }

  render () {
    const {
      onCondicionChange,
      data,
      calificacionCalles,
      cea,
      cpe,
      cpa,
      caladoImpresora,
      showCaladoConfirmacionAnulacion,
      humedad,
      openDialogPatente,
      onPrev
    } = this.props

    return (
      <>
        <Container fluid className='container-proceso-calado'>
          <Col className='container-calificacion d-flex'>
            <CampoHumedad
              humedad={humedad}
              max={this.props.maxValorHumedad}
              min={this.props.minValorHumedad}
              updateHumedad={this.props.updateHumedad}
            />
            <div className='flex-nowrap container-condicion-ingreso'>
              <CondicionIngreso onChange={onCondicionChange} />
            </div>
          </Col>
          <Col className='container-seleccion-calle-calado'>
            <CalleGrande style={{ margin: '0 auto' }} data={data} cpa={cpa} calificacionCalles={calificacionCalles} />
          </Col>
          <Col className='d-flex container-graficos'>
            <div className='container-calado-switches'>
              <CaladoSwitch />
              <div style={{ margin: '0', paddingTop: '5%' }}>
                <IconButton style={{ outline: 'none' }} onClick={() => this.reimpresionEtiquetaIngreso(cpe.nroCtge, caladoImpresora)} >
                  <PrintIcon color='primary' fontSize='large' />
                  <p style={{ margin: '0 10px', fontSize: '1rem', color: '#000000' }}>Reimpresión de Oblea</p>
                </IconButton>
              </div>
            </div>

            <Card className='container-foto-calado'>
              <CardActionArea onClick={openDialogPatente}>
                <img className='foto-calado-chica' src={cpe && cpe.foto} alt='foto-calado' />
              </CardActionArea>
            </Card>
          </Col>
        </Container>
        {cea && <EstadoIngresoAnterior cea={cea} cpa={cpa} onPrev={onPrev} show={showCaladoConfirmacionAnulacion} />}
      </>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    cea: state.calado.consultaCea || {},
    cpe: state.calado.cpe,
    cpa: state.camionesIngreso.consultaCpa,
    humedad: state.calado.humedad,
    impoblea: state.calado.impoblea,
    showCaladoConfirmacionAnulacion: state.calado.showCaladoConfirmacionAnulacion,
    humedadInicial: (state.calado.consultaCea) ? Number(state.calado.consultaCea.humedad) * 10 : state.cereal.cerealEspecie['limiteDeHumedad'] * 10,
    caladoImpresora: state.calado.caladoImpresora,
    maxValorHumedad: state.calado.maxValorHumedad,
    minValorHumedad: state.calado.minValorHumedad
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(CamposProcesoCalado1)
